import routes from './routes';

export const checkoutFeature = {
  name: 'checkout',
  routes,
};
